import React from "react";

//import css
import classes from "./TeamList.module.css";
import classesDark from "./TeamListDark.module.css";

//import component
import TeamMember from "../TeamMember/TeamMember";

//import DataFile
import { TeamData } from "../TeamData";

const TeamList = (props) => {
  let styles = classes;
  if (props.theme) {
    styles = classes;
  } else {
    styles = classesDark;
  }

  const renderMembersByYear = (year) => {
    return TeamData.filter((member) => member.year === year)
      .sort((a, b) => a.cardName.trim().localeCompare(b.cardName.trim()))
      .map((member) => (
        <TeamMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          objectPosition={member.objectPosition}
          imageStyle={member.imageStyle}
          theme={props.theme}
        />
      ));
  };

  const Lead = renderMembersByYear(0);
  const fourthYearList = renderMembersByYear(4);
  const thirdYearList = renderMembersByYear(3);
  const secondYearList = renderMembersByYear(2);

  return (
    <div className={styles.TeamList}>
      {/* <div className={styles.section}>
        <h1 className={styles.teamListHeader}>GDSC Faculty Coordinator</h1>
        <div className={styles.listContainer}>{Faculty}</div>
      </div> */}
      {Lead.length > 0 && (
        <div className={styles.section}>
          <h1 className={styles.teamListHeader}>GDG On Campus Lead</h1>
          <div className={styles.listContainer}>{Lead}</div>
        </div>
      )}
      {fourthYearList.length > 0 && (
        <div className={styles.section}>
          <h1 className={styles.teamListHeader}>Members from 4th Year</h1>
          <div className={styles.listContainer}>{fourthYearList}</div>
        </div>
      )}
      {thirdYearList.length > 0 && (
        <div className={styles.section}>
          <h1 className={styles.teamListHeader}>Members from 3rd Year</h1>
          <div className={styles.listContainer}>{thirdYearList}</div>
        </div>
      )}
      {secondYearList.length > 0 && (
        <div className={styles.section}>
          <h1 className={styles.teamListHeader}>Members from 2nd Year</h1>
          <div className={styles.listContainer}>{secondYearList}</div>
        </div>
      )}
    </div>
  );
};

export default TeamList;
